<main [dir]="direction">
  <router-outlet></router-outlet>
</main>
